<template>
  <div style="height:100%;">
    <van-nav-bar
      title="抽奖活动"
      left-text=""
      left-arrow
      @click-left="onClickLeft()">
    </van-nav-bar>
    <van-notice-bar left-icon="volume-o" :scrollable="false" style="height:25px;">
      <van-swipe vertical class="notice-swipe" :autoplay="1500" :show-indicators="false">
        <van-swipe-item v-for="(item,index) in luckyerList" :key="index">{{item}}</van-swipe-item>
      </van-swipe>
    </van-notice-bar>
    <div class="dial">
      <div style="text-align:right;margin-top:1%;margin-right:5px;">
        <van-tag mark type="danger" size="large" @click="toDrawLog()">抽奖记录</van-tag>
      </div>
      <div style="margin-top:2%;text-align:center;font-weight:bold;">
        <van-tag type="danger" size="large" style="font-size:15px;">
          您还有{{remaindrawChance}}次抽奖机会，再做{{remainNum}}单可获得抽奖一次
        </van-tag>
      </div>
      <div style="text-align:center;">
        <img src="../../assets/draw2024/period2/title_bg.png" style="width:100%;margin-top:2%;" />
      </div>
      <!-- 转盘包裹 -->
      <div class="rotate">
        <!-- 转盘图片 -->
        <img class="dish" src="../../assets/draw2024/period2/dial.png" :style="{transform:rotate_deg,transition:rotate_transition}" />
        <!-- 指针图片 -->
        <img class="pointer" src="../../assets/draw2024/click.png" @click="start" />
      </div>
    </div>

    <van-overlay :show="show5">
      <div class="wrapper">
        <div class="block" catch:tap="noop" >
          <!-- 1 -->
          <div style="width:100%;text-align:center;"><h3>恭喜获得五等奖</h3></div>
          <div style="width:100%;text-align:center;font-size:15px;color:red;">以下奖品二选一，请及时选择奖品并提交</div>
          <!-- 2 -->
          <div style="width:100%;height:45%;margin-top:15%;">
            <div style="float:left;width:50%;text-align:center;">
              <img src="../../assets/draw2024/period2/天力保温杯.png" width="150" height="190" />
            </div>
            <div style="float:left;width:50%;text-align:center;">
              <img src="../../assets/draw2024/period2/不锈钢咖啡壶.png" width="150" height="190" /><br/>
              <a href="javascript:void(0)" style="font-size:14px;text-decoration: underline;color:red;" @click="openView(2)">查看奖品介绍</a>
            </div>
          </div>
          <!-- 3 -->
          <div style="width:100%;height:8%;">
            <van-radio-group v-model="prize" direction="horizontal" @change="selectPrize">
              <van-radio name="天力保温杯" style="width:45%;margin-left:6px;">天力保温杯</van-radio>
              <van-radio name="不锈钢咖啡壶" style="width:45%;margin-left:3px;">不锈钢咖啡壶</van-radio>
            </van-radio-group>
          </div>
          <div style="width:100%;height:5%;" v-if="prize=='不锈钢咖啡壶'">
            <van-radio-group v-model="size" direction="horizontal" @change="selectSize" style="margin-left:6px;">
              <van-radio name="红色">红色</van-radio>
              <van-radio name="白色">白色</van-radio>
            </van-radio-group>
          </div>
          <!-- 4 -->
          <div style="width:100%;height:10%;text-align:center;">
            <van-button type="primary" size="normal" style="width:80px;height:30px;" @click="SavePrize(2)">确 定</van-button>
          </div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="show4">
      <div class="wrapper">
        <div class="block" catch:tap="noop" >
          <!-- 1 -->
          <div style="width:100%;text-align:center;"><h3>恭喜获得四等奖</h3></div>
          <div style="width:100%;text-align:center;font-size:15px;color:red;">以下奖品二选一，请及时选择奖品并提交</div>
          <!-- 2 -->
          <div style="width:100%;height:45%;margin-top:15%;">
            <div style="float:left;width:50%;text-align:center;">
              <img src="../../assets/draw2024/period2/天力冲锋衣.png" width="150" height="190" />
            </div>
            <div style="float:left;width:50%;text-align:center;">
              <img src="../../assets/draw2024/period2/电热水瓶.png" width="150" height="190" /><br/>
              <a href="javascript:void(0)" style="font-size:14px;text-decoration: underline;color:red;" @click="openView(3)">查看奖品介绍</a>
            </div>
          </div>
          <!-- 3 -->
          <div style="width:100%;height:8%;">
            <van-radio-group v-model="prize" direction="horizontal" @change="selectPrize">
              <van-radio name="天力冲锋衣" style="width:45%;margin-left:6px;">天力冲锋衣</van-radio>
              <van-radio name="电热水瓶" style="width:45%;margin-left:3px;">电热水瓶</van-radio>
            </van-radio-group>
          </div>
          <div style="width:100%;height:5%;" v-if="prize=='天力冲锋衣'">
            <van-radio-group v-model="size" direction="horizontal" @change="selectSize" style="margin-left:6px;">
              <van-radio name="L">L</van-radio>
              <van-radio name="XL">XL</van-radio>
              <van-radio name="2XL">2XL</van-radio>
              <van-radio name="3XL">3XL</van-radio>
            </van-radio-group>
          </div>
          <!-- 4 -->
          <div style="width:100%;height:10%;text-align:center;">
            <van-button type="primary" size="normal" style="width:80px;height:30px;" @click="SavePrize(3)">确 定</van-button>
          </div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="show3">
      <div class="wrapper">
        <div class="block" catch:tap="noop" >
          <!-- 1 -->
          <div style="width:100%;text-align:center;"><h3>恭喜获得三等奖</h3></div>
          <div style="width:100%;text-align:center;font-size:15px;color:red;">以下奖品二选一，请及时选择奖品并提交</div>
          <!-- 2 -->
          <div style="width:100%;height:45%;margin-top:15%;">
            <div style="float:left;width:50%;text-align:center;">
              <img src="../../assets/draw2024/period2/数显热熔机.png" width="150" height="190" />
            </div>
            <div style="float:left;width:50%;text-align:center;">
              <!-- <img src="../../assets/draw2024/period2/电饭煲.png" width="150" height="190" /><br/> -->
              <img src="../../assets/draw2024/period2/微压深炖锅.png" width="150" height="190" /><br/>
              <a href="javascript:void(0)" style="font-size:14px;text-decoration: underline;color:red;" @click="openView(4)">查看奖品介绍</a>
            </div>
          </div>
          <!-- 3 -->
          <div style="width:100%;height:5%;">
            <van-radio-group v-model="prize" direction="horizontal" @change="selectPrize">
              <van-radio name="数显热熔机" style="width:45%;margin-left:6px;">数显热熔机</van-radio>
              <van-radio name="微压深炖锅" style="width:45%;margin-left:3px;">微压深炖锅</van-radio>
            </van-radio-group>
          </div>
          <!-- 4 -->
          <div style="width:100%;height:10%;text-align:center;">
            <van-button type="primary" size="normal" style="width:80px;height:30px;" @click="SavePrize(4)">确 定</van-button>
          </div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="show2">
      <div class="wrapper">
        <div class="block" catch:tap="noop" >
          <!-- 1 -->
          <div style="width:100%;text-align:center;"><h3>恭喜获得二等奖</h3></div>
          <div style="width:100%;text-align:center;font-size:15px;color:red;">以下奖品二选一，请及时选择奖品并提交</div>
          <!-- 2 -->
          <div style="width:100%;height:45%;margin-top:15%;">
            <div style="float:left;width:50%;text-align:center;">
              <img src="../../assets/draw2024/period2/按摩足浴桶.png" width="150" height="190" /><br/>
              <a href="javascript:void(0)" style="font-size:14px;text-decoration: underline;color:red;" @click="openView(5)">查看奖品介绍</a>
            </div>
            <div style="float:left;width:50%;text-align:center;">
              <!-- <img src="../../assets/draw2024/period2/微压深炖锅.png" width="150" height="190" /><br/> -->
              <img src="../../assets/draw2024/period2/电饭煲.png" width="150" height="190" /><br/>
              <a href="javascript:void(0)" style="font-size:14px;text-decoration: underline;color:red;" @click="openView(6)">查看奖品介绍</a>
            </div>
          </div>
          <!-- 3 -->
          <div style="width:100%;height:5%;">
            <van-radio-group v-model="prize" direction="horizontal" @change="selectPrize">
              <van-radio name="按摩足浴桶" style="width:45%;margin-left:6px;">按摩足浴桶</van-radio>
              <van-radio name="电饭煲" style="width:45%;margin-left:3px;">电饭煲</van-radio>
            </van-radio-group>
          </div>
          <!-- 4 -->
          <div style="width:100%;height:10%;text-align:center;">
            <van-button type="primary" size="normal" style="width:80px;height:30px;" @click="SavePrize(5)">确 定</van-button>
          </div>
        </div>
      </div>
    </van-overlay>

    <!-- 奖品介绍图片 保温杯 冲锋衣 热熔机无介绍 -->
    <van-overlay :show="showdetail6">
      <div class="wrapper2">
        <div class="block2" catch:tap="noop" >
          <!-- <img src="../../assets/draw2024/period2/detail6.jpg" width="225" height="380" /> -->
          <img src="../../assets/draw2024/period2/detail6.jpg" width="100%" height="100%" />
        </div>
      </div>
      <span class="close" @click="onClickHide(6)"></span>
    </van-overlay>
    <van-overlay :show="showdetail5">
      <div class="wrapper2">
        <div class="block2" catch:tap="noop" >
          <!-- <img src="../../assets/draw2024/period2/detail5.jpg" width="225" height="380" /> -->
          <img src="../../assets/draw2024/period2/detail5.jpg" width="100%" height="100%" />
        </div>
      </div>
      <span class="close" @click="onClickHide(5)"></span>
    </van-overlay>
    <van-overlay :show="showdetail4">
      <div class="wrapper2">
        <div class="block2" catch:tap="noop" >
          <!-- <img src="../../assets/draw2024/period2/detail4.jpg" width="225" height="380" /> -->
          <img src="../../assets/draw2024/period2/detail4.jpg" width="100%" height="100%" />
        </div>
      </div>
      <span class="close" @click="onClickHide(4)"></span>
    </van-overlay>
    <van-overlay :show="showdetail3">
      <div class="wrapper2">
        <div class="block2" catch:tap="noop" >
          <!-- <img src="../../assets/draw2024/period2/detail3.jpg" width="225" height="380" /> -->
          <img src="../../assets/draw2024/period2/detail3.jpg" width="100%" height="100%" />
        </div>
      </div>
      <span class="close" @click="onClickHide(3)"></span>
    </van-overlay>
    <van-overlay :show="showdetail2">
      <div class="wrapper2">
        <div class="block2" catch:tap="noop" >
          <!-- <img src="../../assets/draw2024/period2/detail2.jpg" width="225" height="380" /> -->
          <img src="../../assets/draw2024/period2/detail2.jpg" width="100%" height="100%" />
        </div>
      </div>
      <span class="close" @click="onClickHide(2)"></span>
    </van-overlay>
  </div>
  
</template>
<script>
import { Button, Image, NavBar, NoticeBar, Overlay, Radio, RadioGroup, Swipe, SwipeItem, Tag, Toast  } from "vant";
import { showToast } from 'vant'
import AppVue from "../../App.vue";
var light_timer; //灯光定时器
export default {
  name: "dial",
  data() {
    return {
      // LuckyClick: 3,
      circleList: [], //原点设置
      colorCircleFirst: "#FE4D32", //圆点颜色
      colorCircleSecond: "#fff", //圆点颜色
 
      cat: 60, //总共6个扇形区域，每个区域约60度
      isAllowClick: true, //是否能够点击
      rotate_deg: 0, //指针旋转的角度
      rotate_transition: "transform 3s ease-in-out", //初始化选中的过度属性控制
      remaindrawChance: 0,
      remainNum : 0,
      luckyerList: [],
      show5: false,
      show4: false,
      show3: false,
      show2: false,
      prize: "",
      size: "",
      showdetail6: false,
      showdetail5: false,
      showdetail4: false,
      showdetail3: false,
      showdetail2: false
    };
  },
  created() {
    this.showcircleList();
    this.GetData();
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    //绘制圆点设置
    showcircleList() {
      let circleList = [];
      for (var i = 0; i < 16; i++) {
        circleList.push(i);
      }
      this.circleList = circleList;
      this.light();
    },
 
    //闪动效果
    light: function() {
      var that = this;
      clearInterval(light_timer);
      light_timer = setInterval(function() {
        if (that.colorCircleFirst == "#FE4D32") {
          that.colorCircleFirst = "#fff";
          that.colorCircleSecond = "#FE4D32";
        } else {
          that.colorCircleFirst = "#FE4D32";
          that.colorCircleSecond = "#fff";
        }
      }, 300); //设置圆点闪烁的效果
    },
 
    start() {
      // if (this.remaindrawChance == 0) {
      //   alert("机会已经用完了");
      //   return;
      // }
      this.rotating();
    },
 
    rotating() {
      if (!this.isAllowClick) return;
      this.isAllowClick = false;
      this.rotate_transition = "transform 3s ease-in-out";
      // this.remaindrawChance--;
      // var rand_circle = 5; //默认多旋转5圈

      this.$http
        .get("SDWorker/Lucky2Draw2024?period=2", {
          params: {},
        }).then((res) => {
          if (res.data.Msg == "success") {
            this.remaindrawChance--;
            var rand_circle = 5; //默认多旋转5圈

            console.log(res.data.Data);
            var winningIndex = res.data.Data;
            console.log(winningIndex);
            var randomDeg = 360 - winningIndex*60+60; //当前下标对应的角度    60是总共6个扇形区域，每个区域约60度 （指针停留在奖品中间）
      
            var deg = rand_circle * 360 + randomDeg; //将要旋转的度数  由于是顺时针的转动方向需要用360度来减
            this.rotate_deg = "rotate(" + deg + "deg)";
      
            var that = this;
            setTimeout(function() {
              that.isAllowClick = true;
              that.rotate_deg = "rotate(" + 0 + "deg)"; //定时器关闭的时候重置角度
              that.rotate_transition = "";

              if (winningIndex == 1) {
                that.$toast("恭喜您，获得28.8元积分红包一个");
              } else if (winningIndex == 2) {
                that.show5 = true;
              } else if (winningIndex == 3) {
                that.show4 = true;
              } else if (winningIndex == 4) {
                that.show3 = true;
              } else if (winningIndex == 5) {
                that.show2 = true;
              } else if (winningIndex == 6) {
                that.$toast("恭喜您，获得2024元积分红包一个");
              }
            }, 3500);

          } else {
            console.log(res.data);
            this.$toast(res.data);
          }
        });
    },
    toDrawLog() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "Luck2DrawRecord2024",
        params: {},
      });
    },
    selectPrize(s) {
      this.prize = s;
    },
    selectSize(s) {
      this.size = s;
    },
    openView(s) {
      if(s==2){
        this.showdetail2 = true;
      }else if(s==3){
        this.showdetail3 = true;
      }else if(s==4){
        this.showdetail4 = true;
      }else if(s==5){
        this.showdetail5 = true;
      }else{
        this.showdetail6 = true;
      }
    },
    onClickHide(s) {
      if(s==2){
        this.showdetail2 = false;
      }else if(s==3){
        this.showdetail3 = false;
      }else if(s==4){
        this.showdetail4 = false;
      }else if(s==5){
        this.showdetail5 = false;
      }else{
        this.showdetail6 = false;
      }
    },
    GetData() {
      var that = this;
      that.$http.get("SDWorker/Get2Luckyer2024?period=2").then((res) => {
        that.luckyerList = res.data.ListData;
      });
      that.$http.get("SDWorker/GetDrawChance2024?period=2").then((res) => {
        that.remaindrawChance = res.data.Data.RemainChance;
        that.remainNum = res.data.Data.RemainNum;
      });
    },
    SavePrize(num) {
      var that = this;
      if(that.prize==""){
        return that.$toast.fail("请先选择奖品");
      }
      if(that.prize=="不锈钢咖啡壶" && that.size==""){
        return that.$toast.fail("请先选择颜色");
      }
      if(that.prize=="天力冲锋衣" && that.size==""){
        return that.$toast.fail("请先选择尺码");
      }
      that.$http.get("SDWorker/SaveDraw", {
          params: {
            winningNum: num,
            prize: that.prize,
            size: that.size
          },
        }).then((res) => {
          if (res.data == "success") {
            this.$toast("提交成功~");
            this.$router.push({
              name: "Luck2Draw2024",
              params: {},
            });
            // 关闭遮罩层
            this.show5=false;
            this.show4=false;
            this.show3=false;
            this.show2=false;
          } else {
            that.$toast(res.data);
          }
      });
    },
     onClickLeft() {
      this.$router.back(-1);
    },
    noop() {},
 
    //设置概率
    set() {
      var winIndex;
      //方法2
      var __rand__ = Math.random();
      if (__rand__ < 0.3) winIndex = 2;
      else if (__rand__ < 0.6) winIndex = 1;
      else if (__rand__ < 0.99) winIndex = 4;
      else if (__rand__ < 0.92) winIndex = 3;
      else if (__rand__ == 0.99) winIndex = 0;
 
      return winIndex;
    }
  },
  components: {
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [NoticeBar.name]: NoticeBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Overlay.name]: Overlay,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
  },
};
</script>
<style scoped>
.dial{
  height: 100%;
  width: 100%;
  position: relative;
  background-image: url('../../assets/draw2024/draw_bg.jpg');
  background-repeat:no-repeat;
  overflow: hidden;
  background-size: contain;
}
.times {
  text-align: center;
  line-height: 1.8rem;
  background: #fff;
}
.rotate {
  width: 21.1rem;
  height: 21.1rem;
  /* background: #ffbe04; */
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 52%;
  left: 50%;
  transform: translate(-50%, -50%);
}
 
.rotate .dish {
  width: 22rem;
  height: 22rem;
}
 
.pointer {
  width: 10.25rem;
  height: 12.65rem;
  position: absolute;
  top: 36%;
  left: 50.5%;
  transform: translate(-50%, -50%);
}
 
.prize {
  background: rgba(0, 0, 0, 0.25);
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -ms-grid-row-align: center;
  align-items: center;
  z-index: 100;
}

.notice-swipe {
  height: 40px;
  line-height: 40px;
}


.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 90%;
  height: 75%;
  background-color: #fff;
}


.wrapper2 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block2 {
  width: 60%;
  height: 55%;
  background-color: #fff;
}
/* .block2 {
  width: 225px;
  height: 380px;
  background-color: #fff;
} */

.close {
  background: #fff;
  color: #3c3c3c;
  border: 1px solid #3c3c3c;
  border-radius: 100%;
  text-align: center;
  line-height: 20px;
  height: 20px;
  width: 20px;
  font-size: 18px;
  padding: 1px;
  /* top: 140px;
  right: 60px; */
  top: 21%;
  right: 17%;
  position: absolute;
}
.close::before{
  content: "\2716";
}
</style>